import React from 'react';
import { Link } from "react-router-dom";

import DocsVideo from '../reusable_components/DocsVideo';

import place_students_start_placing_screen from '../images/place_students_start_placing_screen.png';
import place_students_generate_in_progress from '../videos/place_students_generate_in_progress.mov';
import place_students_subscription_missing from '../images/place_students_subscription_missing.png';
import place_students_schedule_complete from '../videos/place_students_schedule_complete.mov';

export default function PlaceStudentsDocs({ topic, setTopic, schoolType }) {
	const validTopics = ['place_students'];
	const placeStudentsTopic = validTopics.includes(topic) ? topic : 'default';

	const choosePlaceStudentsTopic = (newTopic) => {
		if (placeStudentsTopic === newTopic) {
			setTopic(null);
		} else {
			setTopic(newTopic);
		}

		scrollToInstructions('topOfThePage');
	};

	const scrollToInstructions = (sectionId) => {
		const section = document.getElementById(sectionId);
		if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
	};

	return (
		<div className='documentation-page'>
			<div id='topOfThePage' className='step-main-heading'>Place Students</div>
			<p>This is the final scheduling step. In this screen you run student placement, wait for processing, and then review the completed schedule in magnetboard.</p>
			<p className='documentation-question-heading'>What do you need help with?</p>
			<div className='choose-topic' style={{ margin: '0px 0px 10px 0px' }}>
				<Link className={`choose-topic-btn ${placeStudentsTopic === 'place_students' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/scheduling_wizard/place_students/${placeStudentsTopic === 'place_students' ? 'null' : 'place_students'}`} onClick={() => choosePlaceStudentsTopic('place_students')}>Place Students</Link>
			</div>

			{placeStudentsTopic === 'place_students' &&
			<div className='documentation-container'>
				<h2 className='documentation-page-heading'>Place Students</h2>
				<div className='documentation-question-heading'>Where are you stuck?</div>
				<div className='documentation-container-instruction-option-container'>
					<div className='documentation-container-instruction-option blue-link' onClick={() => scrollToInstructions('place_students_start')}>Start placing students</div>
					<div className='documentation-container-instruction-option blue-link' onClick={() => scrollToInstructions('place_students_progress')}>Understand progress and waiting states</div>
					<div className='documentation-container-instruction-option blue-link' onClick={() => scrollToInstructions('place_students_subscription')}>If subscription is missing</div>
					<div className='documentation-container-instruction-option blue-link' onClick={() => scrollToInstructions('place_students_done')}>Open the completed schedule</div>
				</div>

				<div id='place_students_start' className='documentation-container-instruction-container'>
					<div className='documentation-container-instruction-heading'>Start placing students</div>
					<div className='documentation-step-text'>Once all previous steps are complete, admins can start this step by clicking <span className='turquoise-text'>Place Students</span> on the Place Students screen.</div>
					<div className='documentation-step-text'>After this starts, Edario places students into sections automatically and then recalculates conflicts and match percent when it finishes.</div>
					<img className='documentation-screen-image' src={place_students_start_placing_screen} alt='placeholder for start placing students' />
				</div>

				<div id='place_students_progress' className='documentation-container-instruction-container'>
					<div className='documentation-container-instruction-heading'>Understand progress and waiting states</div>
					<div className='documentation-step-text'>While placement runs, you should see a loading animation and a message that students are being placed.</div>
					<div className='documentation-step-text'>Supervisors can see the waiting/progress message even if they cannot start placement themselves, so they know the run is in progress.</div>
					<DocsVideo src={place_students_generate_in_progress}></DocsVideo>
				</div>

				<div id='place_students_subscription' className='documentation-container-instruction-container'>
					<div className='documentation-container-instruction-heading'>If subscription is missing</div>
					<div className='documentation-step-text'>If your school does not have this feature enabled, you will see a subscription notice and can skip to the next step.</div>
					<div className='documentation-step-text'>Admins can contact support (contact@edario.com) to enable full placement generation features.</div>
					<img className='documentation-screen-image' src={place_students_subscription_missing} alt='placeholder for missing subscription' />
				</div>

				<div id='place_students_done' className='documentation-container-instruction-container'>
					<div className='documentation-container-instruction-heading'>Open the completed schedule</div>
					<div className='documentation-step-text'>When placement is complete, Edario shows a completion message and a button to continue.</div>
					<div className='documentation-step-text'>Click <span className='turquoise-text'>Go to Magnetboard</span> to review and fine-tune the final schedule.</div>
					<DocsVideo src={place_students_schedule_complete}></DocsVideo>
				</div>
			</div>
			}
		</div>
	);
}
